
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sendgrid",
      function () {
        return require("private-next-pages/destinations/sendgrid.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sendgrid"])
      });
    }
  